import { Grid, makeStyles } from "@material-ui/core";
import { useQuery } from "@redux-requests/react";
import { filter, isEmpty } from "lodash";
import React, { useEffect } from "react";
import { useIntl } from "react-intl";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { BaseLayout, Header, Loader, NoData } from "../components";
import CardItem from "../components/CardItem";
import { types } from "../ducks";
import { getExhibitors } from "../ducks/actions";
import { ReactComponent as CompaniesSvg } from "../assets/icons/companies.svg";

const useStyles = makeStyles(theme => ({
  root: {
    "& > *": {
      marginBottom: theme.spacing(3)
    }
  },
  sponsorLevelRow: {
    marginBottom: "2.4rem"
  }
}));

const ExhibitorsPage = () => {
  const classes = useStyles();
  const intl = useIntl();
  const history = useHistory();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getExhibitors());
  }, [dispatch]);

  const {
    data: { data: exhibitors },
    loading
  } = useQuery({ type: types.GET_EXHIBITORS, defaultData: { data: [] } });

  const onCompanyClick =
    ({ id }) =>
    () => {
      history.push(`/companies/${id}`);
    };

  const sizeBySponsorLevel = ({ sponsorLevel }) => {
    switch (sponsorLevel) {
      case "gold":
        return { xs: 12, sm: 6 };
      case "silver":
        return { xs: 6, sm: 4 };
      case "bronze":
      default:
        return { xs: 4, sm: 3 };
    }
  };

  const goldExihibitors = filter(exhibitors, e => e.sponsorLevel === "gold");
  const silverExihibitors = filter(exhibitors, e => e.sponsorLevel === "silver");
  const bronzeExihibitors = filter(exhibitors, e => e.sponsorLevel === "bronze");

  return (
    <BaseLayout className={classes.root}>
      <Header
        icon={CompaniesSvg}
        title={intl.formatMessage({
          id: "Pages.ExhibitorsPage.Exhibitors",
          defaultMessage: "Exhibitors"
        })}
      />
      <Loader loading={loading}>
        <NoData
          message={intl.formatMessage({
            id: "Pages.ExhibitorsPage.NoExhibitors",
            defaultMessage: "There are no companies. Please check later for new contents..."
          })}
          data={exhibitors}
        >
          {/* Gold */}
          {!isEmpty(goldExihibitors) && (
            <Grid container spacing={3} className={classes.sponsorLevelRow}>
              {goldExihibitors.map(({ id, name, description, sponsorLevel, logo }) => (
                // eslint-disable-next-line react/jsx-props-no-spreading
                <Grid item xs={12} {...sizeBySponsorLevel({ sponsorLevel })} key={id}>
                  <CardItem
                    title={name}
                    description={description}
                    thumbUrl={logo}
                    onClick={onCompanyClick({ id })}
                    noCover
                  />
                </Grid>
              ))}
            </Grid>
          )}

          {/* Silver */}
          {!isEmpty(silverExihibitors) && (
            <Grid container spacing={3} className={classes.sponsorLevelRow}>
              {silverExihibitors.map(({ id, name, description, sponsorLevel, logo }) => (
                // eslint-disable-next-line react/jsx-props-no-spreading
                <Grid item xs={12} {...sizeBySponsorLevel({ sponsorLevel })} key={id}>
                  <CardItem
                    title={name}
                    description={description}
                    thumbUrl={logo}
                    onClick={onCompanyClick({ id })}
                    noCover
                  />
                </Grid>
              ))}
            </Grid>
          )}

          {/* Bronze */}
          {!isEmpty(bronzeExihibitors) && (
            <Grid container spacing={3} className={classes.sponsorLevelRow}>
              {bronzeExihibitors.map(({ id, name, description, sponsorLevel, logo }) => (
                // eslint-disable-next-line react/jsx-props-no-spreading
                <Grid item xs={12} {...sizeBySponsorLevel({ sponsorLevel })} key={id}>
                  <CardItem
                    title={name}
                    description={description}
                    thumbUrl={logo}
                    onClick={onCompanyClick({ id })}
                    noCover
                  />
                </Grid>
              ))}
            </Grid>
          )}
        </NoData>
      </Loader>
    </BaseLayout>
  );
};

export default ExhibitorsPage;
